module.exports = __webpack_public_path__ + "static/zdjęcia4-c8f6b64a70a698ba03bf3aac108b99da.svg";